export default __webpack_public_path__ + "static/media/A0003.6e8c417e.png";